// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#default-layout{margin-top:125px}main{min-height:calc(100vh - 225px);padding:25px}@media(max-width:576px){main{padding:15px 10px}}.explanation-popup-content{padding:15px 25px 25px}.explanation-popup-content h1{margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
